module.exports = __webpack_public_path__ + "media/images/healthcare-56eea038263485caaaeb34a09802053f.png";